import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly LANGUAGE_KEY = 'user-language';
  private currentLanguageSubject = new BehaviorSubject<string>('es');
  
  public currentLanguage$ = this.currentLanguageSubject.asObservable();

  constructor(private translate: TranslateService) {
    this.initializeLanguage();
  }

  private initializeLanguage(): void {
    // Obtener idioma guardado o usar el del navegador
    const savedLanguage = localStorage.getItem(this.LANGUAGE_KEY);
    const browserLanguage = this.translate.getBrowserLang();
    
    let languageToUse = 'es'; // Default
    
    if (savedLanguage) {
      languageToUse = savedLanguage;
    } else if (browserLanguage && ['es', 'en'].includes(browserLanguage)) {
      languageToUse = browserLanguage;
    }
    
    this.setLanguage(languageToUse);
  }

  setLanguage(lang: string): void {
    if (['es', 'en'].includes(lang)) {
      this.translate.use(lang);
      this.currentLanguageSubject.next(lang);
      localStorage.setItem(this.LANGUAGE_KEY, lang);
    }
  }

  getCurrentLanguage(): string {
    return this.currentLanguageSubject.value;
  }

  getAvailableLanguages(): Array<{code: string, name: string, flag: string}> {
    return [
      { code: 'es', name: 'Español', flag: 'spn' },
      { code: 'en', name: 'English', flag: 'eng' }
    ];
  }
} 